import { Entry } from '../Entry'

export function Entry20230525() {
  return (
    <Entry title="May 25 2023 - v3.4.1">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13865/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
